let userHelpers = {
  isAdmin() {
    return ['owner', 'admin', 'teacher'].indexOf(this.role) > -1
  },
}

let currentUser = window.$currentUser
if (!currentUser) {
  if (window.ww.xstore) {
    currentUser = window.ww.xstore.state.user
  }
}

export default Object.assign(userHelpers, currentUser)
